{
  "version": "1.2.6",
  "objects": {
    "7452341992065251709": {
      "type": "frame",
      "id": "7452341992065251709",
      "z": -80,
      "textContent": "",
      "left": 2154.213326640339,
      "top": -251.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 1.1088629399607317,
      "scaleY": 0.8182379788611093,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452342203058680476": {
      "type": "frame",
      "id": "7452342203058680476",
      "z": -100,
      "textContent": "Frame 57",
      "left": 2184.213326640339,
      "top": 102.18891274103962,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.05,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452341992065251709",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7452342176716223056": {
      "type": "shape",
      "id": "7452342176716223056",
      "z": 9344,
      "shapeName": "text",
      "textContent": "<p>Description</p>",
      "left": 2184.213326640339,
      "top": 102.18891274103962,
      "width": 444.1924644595333,
      "height": 29.015542656896027,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7452342203058680476",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452342030235203589": {
      "type": "frame",
      "id": "7452342030235203589",
      "z": -90,
      "textContent": "Frame 56",
      "left": 2184.213326640339,
      "top": -190.92719506667336,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.5662322156154259,
      "fill": "#F7F2FC",
      "opacity": 1,
      "container": "7452341992065251709",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452342481467631859": {
      "type": "wireframe",
      "id": "7452342481467631859",
      "z": 9339,
      "top": -134.74639580520815,
      "left": 2288.019733777566,
      "width": 150,
      "height": 150,
      "scaleX": 1.1728824113989231,
      "scaleY": 1.131696728565217,
      "container": "7452342030235203589",
      "wireframeName": "image",
      "fill": "#854AD7",
      "textColor": "#333333",
      "style": "image",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452346619734370830": {
      "type": "frame",
      "id": "7452346619734370830",
      "z": 9384,
      "textContent": "Frame 98",
      "left": 2184.213326640339,
      "top": -221.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.042005763245683246,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452341992065251709",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "center"
    },
    "7452346619735607959": {
      "type": "shape",
      "id": "7452346619735607959",
      "z": 8718,
      "shapeName": "icon",
      "textContent": "",
      "left": 2552.631701610356,
      "top": -220.93007668951498,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7452346619734370830",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    }
  }
}
